_BannerFlowApp.directive("confirmClick", function ($timeout, ngDialog, Utils, Notification) {
    return {
        priority: 0,
        restrict: "A",
        replace: false,
        scope: {
            callback: "&confirmClick",
            message: "@confirmText",
            yesButtonText: "@yesButtonText",
            noButtonText: "@noButtonText",
            isLoader: "@isLoader",
            cancelCallback: "&cancelClick",
            errorTexts: "=?errorTexts",
            container: "=?",
            disabled: "=?",
            headerText: "@headerText"
        },
        link: function (scope, element, attrs) {
            scope.headerText = scope.headerText || "Delete";

            element.bind("click", function (e) {
                //Hide eventually settings popovers
                $(".settings-cell").removeClass("open");

                scope.errorMessage = "";

                if (scope.disabled) return;

                if (!scope.isLoader) {
                    e.stopPropagation();
                    e.preventDefault();
                }

                scope.yesButtonText = scope.yesButtonText || "Yes";
                scope.noButtonText = scope.noButtonText || "No";

                var dialog = ngDialog.open({
                    className: "confirm-click-dialog",
                    template: "/legacy-app/js/directives/confirmClick/confirm-click.html",
                    scope: scope,
                    appendTo: "body"
                });

                scope.gotoItem = function (type, slug) {
                    Utils.GotoObject(type, slug);
                    scope.cancel();
                };

                scope.confirm = function () {
                    if (scope.callback) {
                        scope.loading = true;

                        scope.callback().then(
                            function (response) {
                                // show notification
                                if (
                                    !response.ok &&
                                    response.showNotification &&
                                    response.errors &&
                                    response.errors.length > 0
                                ) {
                                    $timeout(function () {
                                        Notification.Show(response.errors[0].error, 6000, "error");
                                        scope.cancel();
                                    });
                                }
                                // show on modal
                                else if (!response.ok && response.errors) {
                                    $timeout(function () {
                                        scope.errorMessage = "";

                                        _.each(response.errors, function (error) {
                                            scope.errorMessage += "<p>{0}</p>".format(error.error);

                                            if (error.usedBy && error.usedBy.length) {
                                                scope.errorMessage +=
                                                    "<table class='table striped' style='text-align:left;margin-bottom: 0;'>";

                                                _.each(error.usedBy, function (item) {
                                                    scope.errorMessage += "<tr>";
                                                    scope.errorMessage +=
                                                        '<td><a onclick=\'angular.element($(".confirm-click-dialog")).scope().gotoItem({0},"{1}")\'>{2}</a></td>'.format(
                                                            item.type,
                                                            item.slug,
                                                            item.name
                                                        );
                                                    scope.errorMessage += "</tr>";
                                                });

                                                scope.errorMessage += "</table>";
                                            }
                                        });

                                        scope.loading = false;
                                    });
                                } else {
                                    scope.cancel();
                                }
                            },
                            function (message) {
                                if (scope.errorTexts) {
                                    if (scope.errorTexts[message.status]) {
                                        scope.errorMessage = scope.errorTexts[message.status];
                                    } else if (message !== "") {
                                        scope.errorMessage = message;
                                    } else {
                                        scope.errorMessage = "Something went wrong";
                                    }
                                } else {
                                    if (typeof message === "object") {
                                        if (message.status === 403) {
                                            scope.errorMessage = "You are not allowed to do this!";
                                        } else {
                                            scope.errorMessage = "Something went wrong.";
                                        }
                                    }
                                }
                                scope.loading = false;
                            }
                        );
                    }
                };

                if (scope.isLoader) {
                    scope.loading = true;

                    scope.callback().then(function () {
                        scope.cancel();
                    });
                } else {
                    $(document).on("keyup", function (e) {
                        if (e.keyCode == 27) {
                            scope.cancel();
                        }
                    });
                }

                scope.cancel = function () {
                    scope.loading = false;
                    $(document).off("keyup");
                    dialog.close();
                };
            });
        }
    };
});
